import { FormControl, FormHelperText, Typography } from "@material-ui/core";
import { useField, useFormikContext } from "formik";
import {
  KeyboardDatePicker,
  KeyboardDatePickerProps,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import DateFnsUtils from "@date-io/date-fns";

interface DatePickerProps
  extends Omit<KeyboardDatePickerProps, "onChange" | "value"> {
  onChange?: KeyboardDatePickerProps["onChange"];
}

interface IFormDateInput extends React.FC<DatePickerProps> {}

const FormDateInput: IFormDateInput = function ({
  name,
  label = name,
  minDate,
  maxDate,
  readOnly = false,
  ...rest
}) {
  const formikContext = useFormikContext();
  const { submitCount } = formikContext;
  const [field, meta, { setTouched, setValue }] = useField<Date>(name);

  const errorText = meta.error && meta.touched ? meta.error : "";
  const hasError = (meta.error && submitCount > 0) || !!errorText;

  return (
    <FormControl error={hasError}>
      <Typography style={{ fontWeight: 600 }}>{label}</Typography>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          InputProps={{ readOnly: true }}
          required={true}
          emptyLabel="Select Date"
          format="dd/MM/yyyy"
          inputVariant="outlined"
          minDate={minDate || undefined}
          maxDate={maxDate || undefined}
          readOnly={readOnly}
          id={`${name}-input`}
          {...rest}
          onChange={(e) => {
            setTouched(true);
            setValue(e);
            if (rest.onChange) {
              rest.onChange(e);
            }
          }}
          error={hasError}
          onBlur={null}
          onError={null}
          value={field.value || null}
        />
      </MuiPickersUtilsProvider>
      <FormHelperText>{errorText}</FormHelperText>
    </FormControl>
  );
};

export { FormDateInput };
